"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var storybook_1 = require("@eyecons/storybook");
function CopyText(_a) {
    var value = _a.value, deps = _a.deps, _b = _a.type, type = _b === void 0 ? 'input' : _b;
    var _c = react_1.useState(false), copied = _c[0], setCopied = _c[1];
    react_1.useEffect(function () { return setCopied(false); }, deps);
    return react_1.default.createElement(storybook_1.Buttons.Copy, { type: type, id: 'video-url', value: value, label: copied ? 'Gekopieerd!' : 'Kopiëren', onClick: function () {
            storybook_1.Helpers.copy(value);
            setCopied(true);
        } });
}
function CopyIcon(_a) {
    var value = _a.value;
    return react_1.default.createElement("div", { className: 'flex' },
        react_1.default.createElement("input", { type: 'text', value: value, className: 'w-full', readOnly: true }),
        react_1.default.createElement("div", { className: 'flex justify-center items-center', onClick: function () { return storybook_1.Helpers.copy(value); } },
            react_1.default.createElement(storybook_1.Icons.Icon, { name: 'clipboard', className: 'w-5 cursor-pointer hover:opacity-50' })));
}
var types = {
    icon: CopyIcon,
    text: CopyText,
    textarea: function (props) { return react_1.default.createElement(CopyText, __assign({}, props, { type: 'textarea' })); },
};
function useCopy(value, type, deps) {
    if (type === void 0) { type = 'text'; }
    var Component = types[type];
    return [
        function () { return react_1.default.createElement(Component, { value: value, deps: deps }); }
    ];
}
exports.default = useCopy;
useCopy.propTypes = {
    value: prop_types_1.default.string.isRequired,
    type: prop_types_1.default.oneOf(['text', 'icon']),
    deps: prop_types_1.default.array,
};
useCopy.defaultProps = {
    type: 'text',
    deps: [],
};
